import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  declare readonly inputTarget: HTMLInputElement

  copy ({ target }: { target: HTMLDivElement }): void {
    const text = target.innerHTML
    this.inputTarget.value = text === '<br>' ? '' : text

    const changeEvent = new Event('change', { bubbles: true })
    this.inputTarget.dispatchEvent(changeEvent)
  }
}
